import React from 'react';
import { Box, Flex, Loader, CardListItem } from '@opendoor/bricks/core';
import { useCurrentWidth } from 'shared/helpers/hooks/useCurrentWidth';
import { useMeasure } from 'shared/helpers/hooks/reactUseOverrides';
import { useSupportContacts } from 'sellDirect/helpers/useSupportContacts';
import { space } from '@opendoor/bricks/theme/eero';
import { SupportCard } from '@opendoor/cinderblocks/buy/SupportCard';

// 925px of page content + 24px of padding on each side on x axis.
const FORM_MAX_WIDTH = '973px';
/**
 * Component that renders a layout for closing task wizard.
 * Contact card should be fixed on the page for desktop and large tablet view.
 *
 * desktop and large tablet (>= 768px):
 * --------------------------
 * |              |         |
 * | page content | contact |
 * |              | card &  |
 * |              | other   |
 * --------------------------
 * mobile and small tablet (< 768px):
 * ----------------
 * |              |
 * | page content |
 * |              |
 * |              |
 * |--------------|
 * | contact card |
 * | & other      |
 * ----------------
 *
 * TODO(Yutong): add component test
 * component-test-check-ignore
 */
export const ClosingTaskWizardLayout: React.FC<{ rightComponent?: React.ReactNode }> = ({
  children,
  rightComponent,
}) => {
  const screenWidth = useCurrentWidth();
  const [containerRef, { width: containerWidth }] = useMeasure();
  return (
    <Flex
      ref={containerRef}
      width="100%"
      maxW={FORM_MAX_WIDTH}
      px={7}
      flexDirection={['column', null, 'row']}
    >
      <Box width={['100%', null, '60%']}>{children}</Box>
      <Box
        width={['100%', null, containerWidth * 0.4 - space[7]]}
        mt={[0, null, 9]}
        ml={[0, null, 7]}
        mb={10}
        top="136px"
        right={(screenWidth - containerWidth) / 2}
      >
        <ContactCard />
        {rightComponent && <Box mt={9}>{rightComponent}</Box>}
      </Box>
    </Flex>
  );
};

const ContactCard: React.FC = () => {
  const { loadingContacts, experiencePartner } = useSupportContacts();

  return (
    <>
      {loadingContacts && (
        <CardListItem p="5">
          <Loader padding="less" />
        </CardListItem>
      )}
      {experiencePartner && (
        <SupportCard
          data-testid="support-contact-card"
          contact={experiencePartner}
          analyticsName="cake-closing-task-support-card"
        />
      )}
    </>
  );
};
